<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.versionCode"
        placeholder="请输入版本编号"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.terminal"
        placeholder="终端"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in APP_VERSION_TERMINAL"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-input
        v-model="listQuery.versionName"
        placeholder="请输入版本名称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.force"
        placeholder="是否强制更新"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in APP_VERSION_FORCE"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true, {}, 'CREATE')"
        >新增</el-button
      >
    </div>

    <div style="margin-bottom: 5px">APP版本数量:{{ total }}</div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        align="center"
        prop="id"
        label="ID"
        width="95"
      ></el-table-column>
      <el-table-column
        label="版本名称"
        align="center"
        prop="versionName"
      ></el-table-column>
      <el-table-column
        label="版本编号"
        align="center"
        prop="versionCode"
      ></el-table-column>
      <el-table-column label="终端" align="center" prop="terminal">
        <template slot-scope="scope">
          {{ getValue(APP_VERSION_TERMINAL, scope.row.terminal) }}
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="状态" align="center">
        <template slot-scope="scope">
          {{ getValue(APP_VERSION_STATUS, scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column
        label="安装包地址"
        align="center"
        prop="downloadUrl"
        width="260px"
      ></el-table-column>
      <el-table-column label="是否强制更新" align="center" prop="isForce">
        <template slot-scope="scope">
          {{ scope.row.isForce ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column
          label="更新说明"
          align="center"
          prop="content"
          width="260px"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="publishTime"
        label="发布时间"
        width="160px"
      >
        <template slot-scope="scope">
          <span>{{ formatApiDate(scope.row.publishTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="ctdate"
        label="创建时间"
        width="160px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="mddate"
        label="修改时间"
        width="160px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="checkDialogFormVisible(true, scope.row, 'UPDATE')"
            >编辑</el-button
          >
          <el-button size="mini" @click="checkStatusVisible(true, scope.row)"
            >编辑状态</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    编辑和新增-->
    <el-dialog
      :title="DIALOG_TITLE_TYPE[dialogType]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="50%"
      top="60px"
      @close="checkDialogFormVisible(false, {})"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="150px"
        style="width: 90%; margin-left:50px;"
      >
        <el-form-item label="终端" prop="terminal">
          <el-radio-group v-model="form.terminal">
            <el-radio
              :label="item.key"
              v-for="(item, index) in APP_VERSION_TERMINAL"
              :key="index"
              >{{ item.value }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="版本名称" prop="versionName">
          <el-input v-model="form.versionName" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="版本编号" prop="versionCode">
          <el-input v-model="form.versionCode" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="是否强制更新" prop="force">
          <el-radio-group v-model="form.force">
            <el-radio
              :label="item.key"
              v-for="(item, index) in APP_VERSION_FORCE"
              :key="index"
              >{{ item.value }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="安装包路径" prop="downloadUrl">
          <UploadAppPacket
              v-if="form.terminal === 'ANDROID'"
              @valueFunc="getValueFunc"
              :model="form.downloadUrl"
              :maxCount="1"
          />
          <el-input
            v-if="form.terminal === 'IOS'"
            v-model="form.downloadUrl"
            placeholder="请输入"
          />

        </el-form-item>
        <el-form-item label="更新说明" prop="content">
          <el-input
            type="textarea"
            :rows="2"
            v-model="form.content"
            placeholder="请输入"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkDialogFormVisible(false, {}, '')"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="saveAddOrEditData"
          :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!--    编辑状态-->
    <el-dialog
      title="编辑状态"
      :visible.sync="statusDialogVisible"
      :close-on-click-modal="false"
      width="50%"
      top="60px"
      @close="checkStatusVisible(false, {})"
    >
      <el-form
        ref="statusForm"
        :rules="statusRules"
        :model="statusForm"
        label-position="left"
        label-width="150px"
        style="width: 90%; margin-left:50px;"
      >
        <el-form-item label="状态" prop="force">
          <el-radio-group v-model="statusForm.status">
            <el-radio
              :label="item.key"
              v-for="(item, index) in APP_VERSION_STATUS.filter(item =>
                [1, 2, 3].includes(item.key)
              )"
              :key="index"
              >{{ item.value }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkStatusVisible(false, {})">取消</el-button>
        <el-button type="primary" @click="checkStatus" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  appversionEdit,
  appversionGetList,
  updateAppversionStatus
} from "@/api/system.js";
import {formatApiDate, getFileName, getTableThumbnailImg} from "@/utils/utils";
import {
  DIALOG_TITLE_TYPE,
  getValue,
  APP_VERSION_TERMINAL,
  APP_VERSION_FORCE,
  APP_VERSION_STATUS
} from "@/utils/enumUtile";
import UploadAppPacket from "@/views/components/uploadAppPacket";

export default {
  components: { UploadAppPacket },
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    APP_VERSION_TERMINAL() {
      return APP_VERSION_TERMINAL;
    },
    APP_VERSION_FORCE() {
      return APP_VERSION_FORCE;
    },
    APP_VERSION_STATUS() {
      return APP_VERSION_STATUS;
    }
  },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        terminal: null,
        versionCode: null,
        versionName: null,
        force: null
      },
      dialogFormVisible: false,
      dialogType: "",
      rules: {
        terminal: [
          { required: true, message: "终端不能为空", trigger: "change" }
        ],
        versionCode: [
          { required: true, message: "版本编号不能为空", trigger: "change" }
        ],
        versionName: [
          { required: true, message: "版本名称不能为空", trigger: "change" }
        ],
        force: [
          { required: true, message: "是否强制更新不能为空", trigger: "change" }
        ]
      },
      form: {
        id: 0,
        terminal: null,
        versionCode: null,
        versionName: null,
        force: null,
        downloadUrl: [],
        content: null
      },
      btnLoading: false,
      statusDialogVisible: false,
      statusRules: {
        status: [{ required: true, message: "状态不能为空", trigger: "change" }]
      },
      statusForm: {
        id: 0, //
        status: null
      }
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    getValue,
    getTableThumbnailImg,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询用户列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      appversionGetList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 切换状态
     * @param status
     * @param editObj
     * @param type
     */
    checkDialogFormVisible(status, editObj = {}, type) {
      if (status && type === "UPDATE") {
        this.form.id = editObj.id;
        this.form.terminal = editObj.terminal;
        this.form.versionCode = editObj.versionCode;
        this.form.versionName = editObj.versionName;
        this.form.force = editObj.isForce ? 1 : 0;
        // this.form.downloadUrl = editObj.downloadUrl;
        this.form.content = editObj.content;
        if (editObj.downloadUrl) {
          const attDataArr = [];
          attDataArr.push({
            url: editObj.downloadUrl,
            dbUrl: editObj.downloadUrl,
            name: getFileName(editObj.downloadUrl)
          });
          this.form.downloadUrl = attDataArr;
        }
      }
      if (!status) {
        this.form.id = 0;
        this.form.terminal = null;
        this.form.versionCode = null;
        this.form.versionName = null;
        this.form.force = null;
        this.form.downloadUrl = [];
        this.form.content = null;
        this.$refs.form.resetFields();
      }
      this.dialogType = type;
      this.dialogFormVisible = status;
    },

    /**
     * 确认添加还是编辑
     */
    saveAddOrEditData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const form = this.form;
          const params = {
            terminal: form.terminal,
            versionCode: form.versionCode,
            versionName: form.versionName,
            force: form.force,
            content: form.content
          };
          if (form.downloadUrl && form.downloadUrl.length !== 0) {
            const urlArr = form.downloadUrl.map(obj => obj["dbUrl"]);
            params.downloadUrl = urlArr.join(",");
          }
          if (form.id && form.id !== 0) {
            params.id = form.id;
          }
          this.btnLoading = true;
          appversionEdit(params)
            .then(() => {
              this.getList();
              this.checkDialogFormVisible(false);
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    // 编辑状态
    checkStatusVisible(status, editObj = {}) {
      this.statusDialogVisible = status;
      if (status) {
        this.statusForm.id = editObj.id;
        this.statusForm.status = editObj.status;
      } else {
        this.statusForm.id = 0;
        this.statusForm.status = null;
        this.$refs.statusForm.resetFields();
      }
      this.statusDialogVisible = status;
    },
    /**
     * 编辑状态
     */
    checkStatus() {
      this.$refs["statusForm"].validate(valid => {
        if (valid) {
          const form = this.statusForm;
          const params = {
            id: form.id,
            status: form.status
          };
          updateAppversionStatus(params).then(resp => {
            if (resp && resp.bizcode === 100) {
              this.checkStatusVisible(false, {});
              this.$notify({
                title: "成功",
                message: "修改成功",
                type: "success",
                duration: 2000
              });
              this.getList();
            }
          });
        }
      });
    },
    /**
     *  获取图片的值
     * @param type
     * @param value
     */
    getValueFunc(value) {
      console.log("value",value);
      this.form.downloadUrl = value;
    },
  }
};
</script>
<style scoped lang="scss">
.box-card {
  margin-bottom: 10px;
}
</style>
